/* KidsDreamStore produktsida (2026-11-02): den kortare kolumnen följer med vid skroll och stannar när dess nederkant
   når skärmens nederkant (eller toppen om den ryms) – kolumnerna möts alltid i nederkant. Bara dator (≥750 px).
   Ändrar bara style.top/position på kolumnerna; observerar storlek med ResizeObserver (aldrig MutationObserver → ingen loop). */
(function () {
  var mq = window.matchMedia('(min-width: 990px)');  /* nedre delen är en kolumn under 990 px */
  function headerOffset() {
    var h = document.querySelector('sticky-header, .shopify-section-header-sticky, .section-header');
    if (!h) return 16;
    var cs = getComputedStyle(h);
    return (cs.position === 'sticky' || cs.position === 'fixed') ? h.offsetHeight + 16 : 16;
  }
  function setup(wrap, ls, rs) {
    var left = wrap.querySelector(':scope > ' + ls);
    var right = wrap.querySelector(':scope > ' + rs);
    if (!left || !right) return;
    var inner = right.querySelector('.product__column-sticky');
    function apply() {
      [left, right].forEach(function (c) { c.style.position = ''; c.style.top = ''; c.style.alignSelf = ''; });
      if (inner) inner.style.position = '';
      if (!mq.matches) return;
      left.style.alignSelf = 'start'; right.style.alignSelf = 'start';   /* naturlig höjd (grid sträcker annars båda) */
      var lh = left.offsetHeight, rh = right.offsetHeight;
      left.style.alignSelf = ''; right.style.alignSelf = '';
      /* Bilden kortast → temats egen klistring i överkant (som live). Bara när högerkolumnen är kortast tar skriptet över. */
      if (rh >= lh - 40) return;
      if (inner) inner.style.position = 'static';
      right.style.alignSelf = 'start';
      var short = right, sh = rh;
      var off = headerOffset(), vh = window.innerHeight;
      short.style.position = 'sticky';
      var bar = document.querySelector('.kds-sticky-atc') ? 88 : 0;   /* fast köpknapp i nederkant (2026-11-03) */
      short.style.top = (sh + off + 16 + bar <= vh ? off : vh - sh - 16 - bar) + 'px';
    }
    var t; function later() { clearTimeout(t); t = setTimeout(apply, 120); }
    apply();
    if (window.ResizeObserver) { var ro = new ResizeObserver(later); ro.observe(left); ro.observe(right); }
    window.addEventListener('resize', later);
    window.addEventListener('load', later);
  }
  function init() {
    document.querySelectorAll('.product_wrapper.comp-product').forEach(function (w) { setup(w, '.product__media-wrapper', '.product__info-wrapper'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

